import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import RadioField from '../../app-main/components/reduxForms/fields/RadioField/RadioField';
import NumberField from '../../app-main/components/reduxForms/fields/NumberField/NumberField';
import { CLEANING_FEE_FORM } from './constants';
import onSubmitCleaningFeeForm from './submit/onSubmitCleaningFeeForm';
import onChangeCleaningFeeForm from './change/onChangeCleaningFeeForm';
import validateCleaningFeeRateForm from './validate/validateCleaningFeeRateForm';
import Currency from '../../elements-prices/Currency';
import { injectIntl, intlShape } from 'react-intl';

const CleaningFeeForm = ({
  isCleaningFeeActive,
  initialValues,
  handleSubmit,
  dispatch,
  listing,
  intl
}) => {
  const listingId = get(listing, '_id', '');

  return (
    <div>
      <Field
        initialValues={initialValues}
        onChange={(e, newValue) => onChangeCleaningFeeForm(newValue, dispatch)}
        component={RadioField}
        name="cleaning_fee.obj_state"
        className="margin-lg-bottom"
        errorMessage={intl.formatMessage({ id: 'hosting.cleaning_fee_form.cleaning_error_message', defaultMessage: 'Please select an option' })}
        options={[
          {
            id: `cleaning-fee-deactivated-${listingId}`,
            value: 'DEACTIVATED',
            label: intl.formatMessage({ id: 'hosting.cleaning_fee_form.include_rate_label', defaultMessage: 'Included in hourly rate' })
          },
          {
            id: `cleaning-fee-activated-${listingId}`,
            value: 'ACTIVATED',
            label: intl.formatMessage({ id: 'hosting.cleaning_fee_form.additonal_rate_label', defaultMessage: 'Additional flat fee' })
          }
        ]}
      />
      {
        isCleaningFeeActive &&
          <Field
            onBlur={handleSubmit(onSubmitCleaningFeeForm)}
            initialValues={initialValues}
            className="CleaningFeeActiveInput"
            preInputElements={
              <Currency
                className="input-group-addon"
                id="base-rate"
                currency={get(listing, 'prices.0.currency')}
              />
            }
            placeholder={intl.formatMessage({ id: 'hosting.cleaning_fee_form.cleaning_fee_placeholder', defaultMessage: 'Cleaning fee' })}
            component={NumberField}
            name="cleaning_fee.value"
            validate={validateCleaningFeeRateForm}
            errorMessage={intl.formatMessage({ id: 'hosting.cleaning_fee_form.price_error_message', defaultMessage: 'Please enter a valid price' })}
          />
      }
    </div>
  );
};

CleaningFeeForm.propTypes = {
  isCleaningFeeActive: PropTypes.bool.isRequired,
  initialValues: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  listing: PropTypes.object.isRequired,
  intl: intlShape
};

const config = {
  form: CLEANING_FEE_FORM,
  enableReinitialize: true,
  onSubmit: onSubmitCleaningFeeForm
};

const selector = formValueSelector(CLEANING_FEE_FORM);
const mapStateToProps = (state) => {
  const isCleaningFeeActive = selector(state, 'cleaning_fee.obj_state');

  return {
    isCleaningFeeActive: 'ACTIVATED' === isCleaningFeeActive
  };
};

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(CleaningFeeForm)));
